import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

// V2 API client for new endpoints
const apiV2 = axios.create({
  baseURL: '/api/v2',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

// V3 API client for latest endpoints
const apiV3 = axios.create({
  baseURL: '/api/v3',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

// Shared request interceptor function
const createRequestInterceptor = (client: any) => {
  return client.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // FormDataの場合はContent-Typeを削除してaxiosに自動設定させる
      // 通常のオブジェクトの場合はJSON形式を設定
      if (config.data instanceof FormData) {
        // FormDataの場合はContent-Typeを削除してaxiosに境界値付きで自動設定させる
        delete config.headers['Content-Type'];
      } else if (config.data && typeof config.data === 'object') {
        // JSON送信の場合のみContent-Typeを設定
        config.headers['Content-Type'] = 'application/json';
      }

      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );
};

// Apply interceptors to all clients
createRequestInterceptor(api);
createRequestInterceptor(apiV2);
createRequestInterceptor(apiV3);

// Shared response interceptor function
const createResponseInterceptor = (client: any) => {
  return client.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      if (error.response?.status === 401) {
        // Handle unauthorized access
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_token_metadata');

        // Only redirect if not on login page already
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );
};

// Apply interceptors to all clients
createResponseInterceptor(api);
createResponseInterceptor(apiV2);
createResponseInterceptor(apiV3);

export default api;
export { apiV2, apiV3 };

// Export as apiClient for backward compatibility (points to V3 for new implementations)
export const apiClient = apiV3;